import { Box, useMediaQuery as measureScreenWidth } from "@mui/material";
import { common } from "@mui/material/colors";
import { SystemStyleObject, Theme } from "@mui/system";
import { largeTabletAndUp } from "../../lib/responsiveHelpers";
import { ltrTheme } from "../../theme";

export const chatWidth = ltrTheme.spacing(38);

const callChatContainerBaseStyle: SystemStyleObject<Theme> = {
  position: "absolute",
  right: 0,
  height: 1,
  zIndex: "tooltip", // 1500
  background: common.white,
};

const callChatContainerStyle: SystemStyleObject<Theme> = {
  ...callChatContainerBaseStyle,
  top: 0,
  width: chatWidth,
};

const callChatContainerMobileTabletStyle: SystemStyleObject<Theme> = {
  ...callChatContainerBaseStyle,
  bottom: 0,
  borderRadius: `${ltrTheme.spacing(2)} ${ltrTheme.spacing(2)} 0 0`,
  width: 1,
  height: 0.92,
};

type Props = {
  children: React.ReactNode;
};

export default function CallPanel({ children }: Props) {
  const isLargeTabletAndUp = largeTabletAndUp(measureScreenWidth);

  return (
    <Box
      sx={
        isLargeTabletAndUp
          ? callChatContainerStyle
          : callChatContainerMobileTabletStyle
      }
    >
      {children}
    </Box>
  );
}
